
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Grid } from '@mui/material'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import CheckboxField from 'components/atoms/fields/CheckboxField'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'

import formModel, { initialValues } from 'utils/formModels/special/consentEvaluationModel'
import { crudColorMap, crudIconMap } from 'utils/helpers'

import { ActionType, IParticipant } from 'types'
import { ScrollToError } from 'components/atoms/ScrollToError'

interface IProps {
  action: ActionType
  id: string
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

const ConsentEvaluationForm: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
 
  const {
    principal_consent_date,
    principal_consent,
    principal_consent_reason,
    parent_consent_date,
    parent_consent,
    parent_consent_reason,
  } = formModel()

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values: any) => {
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>
            <ScrollToError/>
            <Grid container spacing={2}>

              <Grid item xs={12} md={4}>
                <DatePickerField fieldProps={{ ...principal_consent_date }} />
              </Grid>
              <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                 <CheckboxField fieldProps={{ ...principal_consent }} />
              </Grid>
              <Grid item xs={12}  sx={{ marginBottom: '2rem' }}>
                <InputField multiline={true} fieldProps={{ ...principal_consent_reason }}  />
              </Grid>

                
              <Grid item xs={12} md={4}>
                <DatePickerField fieldProps={{ ...parent_consent_date }} />
              </Grid>
              <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                 <CheckboxField fieldProps={{ ...parent_consent }} />
              </Grid>
              <Grid item xs={12}>
                <InputField multiline={true} fieldProps={{ ...parent_consent_reason }}  />
              </Grid>


              <Grid item xs={12}>
                <SubmitButton
                    color={crudColorMap[action]}
                    text={`Save`}
                    icon={crudIconMap[action]}
                    sx={{ width: '10rem' }}
                    isLoading={false}
                />
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default ConsentEvaluationForm
